<template>
  <PanelV2
    type="w9"
    mode="simple"
    showGoBack
  >
    <template v-slot:content-solt>
      <span class="title">Enter your email address</span>
      <span class="sub-title">Please provide the email address registered in your account.</span>
      <el-form ref="email" :model="formData" @submit.native.prevent>
        <el-form-item label="Email Address" prop="email" :rules="[{ required: true, message: 'Email Address is error'}]">
          <el-input placeholder="Email Address" v-model="formData.email" maxlength="32"  />
        </el-form-item>
      </el-form>
      <span class="link" @click="$router.push({path: '/forgot-email'})">I forgot my email</span>

      <el-button type="primary" @click="next()" >Next</el-button>
    </template>
  </PanelV2>
</template>

<script>
  import API from "@/api"
  export default {
    name: 'ForgotPassword',
    pRouter: 'NeedHelp',
    data() {
      return {
        formData: {
          email: ''
        }
      }
    },
    methods: {
      next() {
        this.$refs.email.validate((valid) => {
          if (valid) {
            API.sendVerifycode({email: this.formData.email}).then(res => {
              if (res.success) {
                sessionStorage.setItem('email', this.formData.email)
                this.toNext()
              }
            })
          } else {
            return false;
          }
        });
      }
    }
  }
</script>


<style lang="scss" scoped>
  .panel-v2 {
    
    .title {
      width: 100%;
      font: normal normal normal 20px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .sub-title {
      margin: 24px 0 0;
      font: normal normal normal 16px/24px Nunito;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .link {
      cursor: pointer;
      margin: 48px 0 0;
      font: normal normal normal 16px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #0072D8;
    }

    .el-button {
      margin: 171px 0 0;
      width: 100%;
    }
    
  }


</style>
